import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, input, model, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { FoxeraDrawerBottomComponent } from '@foxera/shared/components/foxera-drawer-bottom/foxera-drawer-bottom.component';
import { ResponsiveService } from '@foxera/shared/services/responsive.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  imports: [CommonModule, FormsModule, Button, FoxeraDrawerBottomComponent],
  standalone: true
})
export class ConfirmationDialogComponent {
  private responsiveService = inject(ResponsiveService);

  @Input() confirmLabel: string = 'Yes';
  @Input() cancelLabel: string = 'No';
  @Input() confirmSeverity: 'primary' | 'secondary' | 'danger' = 'primary';
  @Input() isLoading: boolean = false;
  @Input() loadingLabel: string = 'Loading...';
  /** When true, overlay is scoped to the parent panel (quad view) instead of the viewport. */
  readonly quadView = input<boolean>(false);
  
  readonly isVisible = model<boolean>(false);
  readonly heading = model<string>('Confirmation');
  readonly subtitle = model<string>('Are you sure you want to proceed with this action?');
  readonly icon = model<string>('icon-warning'); // Default warning icon

  @Output() confirmed = new EventEmitter<void>();
  // 'close' (the X) is always a no-op dismissal, unlike 'button' which some callers repurpose.
  @Output() cancelled = new EventEmitter<'button' | 'close'>();

  // Use responsive service for mobile detection
  readonly isMobile = this.responsiveService.isMobileView;

  onConfirm() {
    this.confirmed.emit();
  }

  onCancel() {
    this.isVisible.set(false);
    this.cancelled.emit('button');
  }

  onClose() {
    this.isVisible.set(false);
    this.cancelled.emit('close');
  }
}
